export class ForbiddenError extends Error {
    constructor() {
        super();
        this.name = "ForbiddenError";
    }
}

export class NotSupportedError extends Error {
    constructor() {
        super();
        this.name = "NotSupportedError";
    }
}